export type MobilePlatform = 'android' | 'ios' | null

/**
 * Detect Android / iOS (including iPad) from the browser user agent.
 * Returns null for desktop and other platforms (stay on web).
 */
export function detectMobilePlatform(
  userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '',
  maxTouchPoints = typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0,
): MobilePlatform {
  if (/android/i.test(userAgent)) return 'android'

  // Classic iOS devices
  if (/iPad|iPhone|iPod/.test(userAgent)) return 'ios'

  // iPadOS 13+ often reports as Macintosh with touch support
  if (/Macintosh/.test(userAgent) && maxTouchPoints > 1) return 'ios'

  return null
}
